import { render, staticRenderFns } from "./StaffSetRole.vue?vue&type=template&id=4960a57b&"
import script from "./StaffSetRole.vue?vue&type=script&lang=js&"
export * from "./StaffSetRole.vue?vue&type=script&lang=js&"
import style0 from "./StaffSetRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports